import { Component, OnInit, ViewEncapsulation } from '@angular/core';

// Custom imports
import { AuthService } from '../auth.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-login',
  providers : [AuthService],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {

  //public errorMessage : string = '';
  //public successMessage : string = '';
  public loginData = {
          email: '',
          password: ''
        };

  constructor(private _authservice: AuthService, private _route: ActivatedRoute, private _notifyService: NotificationService ) { }

  ngOnDestroy() {
  }

  ngOnInit() {
  }

  login() {
    this.loginData.email = this.loginData.email.trim().toLowerCase();
    if(this.loginData.password != '' && this.loginData.email != ''){
      this._authservice.saveUsername(this.loginData.email);
      this._authservice.obtainAccessToken(this.loginData);
    }else{
      this._notifyService.showError("Email et mot de passe obligatoires", "Login", 3000)
      //this.errorMessage = 'Email et mot de passe obligatoires';
    }
  }

  forgotPassword(){
    if(this.loginData.email != ''){
    this._authservice.forgotPassword(this.loginData.email)
    .subscribe(
      data =>{
        this._notifyService.showSuccess("Veuillez consulter votre boite mail ! Nous vous avons envoyé un mail de changement de mot de passe.", "Forgot password", 5000)
      },
      error =>{
        this._notifyService.showError("Une erreur est survenue !", "Forgot password", 3000)
      }
    );
    }else{
      this._notifyService.showError("Email obligatoire", "Forgot password", 3000)
    }
  }

  /*clearMessages(){
    this.errorMessage = '';
    this.successMessage = '';
  }*/

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts